import { Tabs, Tab, Card, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import TabContainer from './TabContainer';

const RequestTabGroup = ({handleContextMenu}) => {
  const [tabValue, setTabValue] = React.useState('headers');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };
  const requestTabs = [
    {
      id: 'headers',
      title: 'Headers',
      // panel: KeyValuePane,
      // paneValue: headers,
      // setPaneValue: setHeaders,
    },
    {
      id: 'body',
      title: 'Body',
      // panel: JsonEditorPane,
      // paneValue: body,
      // setPaneValue: setBody,
    },
    {
      id: 'output',
      title: 'Output Extractors',
      // panel: JsonEditorPane,
      // paneValue: body,
      // setPaneValue: setBody,
    },
  ];
  useEffect(() => {
    setTabValue('headers')
  }, [])
  return (
    <>
      <Card sx={{ p: 1 }}>
        <Tabs
          value={tabValue}
          onChange={handleChange}
          // textColor="secondary"
          // indicatorColor="secondary"
          aria-label="secondary tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: '#2596be',
              color: '#2596be',
            },
          }}
          sx={{ borderBottom: '1px solid #ddd' }}
        >
          {requestTabs.map((tab) => {
            return <Tab value={tab.id} label={
              <Typography sx={{ color: tab.id === tabValue ? '#2596be !important' : '', paddingRight:'16px' }}> {tab.title}</Typography>
            } key={tab.id}/>;
          })}
        </Tabs>

        <TabContainer index={0} value={tabValue} handleContextMenu={(e, fieldName, inputRef) => handleContextMenu(e, fieldName, inputRef)}/>
      </Card>
    </>
  );
};

export default RequestTabGroup;
